<dx-tag-box [dataSource]="dataSource"
            valueExpr="id"
            displayExpr="name"
            [searchEnabled]="true"
            [placeholder]="'Filtrar por lotes'"
            [showSelectionControls]="true"
            selectAllText="Seleccionar todos"
            [readOnly]="tagBoxEnabled"
            [disabled]="tagBoxEnabled"
            (onValueChanged)="onLotsChanged($event)"
            (onClosed)="onHiddenBox($event)"
            [maxDisplayedTags]="1"
            [showMultiTagOnly]="true" style="font-family: 'Poppins', sans-serif;"

>
</dx-tag-box>
